<script lang="ts" module>
  export function nextThinking(count: number, previous: number, random: () => number = Math.random): number {
    if (previous < 0) return Math.floor(random() * count);
    const pick = Math.floor(random() * (count - 1));
    return pick >= previous ? pick + 1 : pick;
  }

  export const THINKING_BEAT_MS = 2500;
</script>

<script lang="ts">
  // The swaps are aria-hidden: the first beat is the one name.
  import { UiKeys } from '@voicedojo/backend-types';
  import { t } from '$lib/i18n';
  import AnimatedDots from './AnimatedDots.svelte';

  interface Props {
    label: string;
  }

  let { label }: Props = $props();

  const words = $derived(Object.values(UiKeys.Thinking).map((key) => t(key)));
  // Auto-updating text is motion too: reduced motion holds the first beat.
  const reducedMotion =
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  let index = $state(-1);
  $effect(() => {
    if (reducedMotion) return;
    const timer = setInterval(() => (index = nextThinking(words.length, index)), THINKING_BEAT_MS);
    return () => clearInterval(timer);
  });

  const shown = $derived((index < 0 ? label : words[index]).replace(/(…|\.\.\.)$/, ''));
</script>

<span class="thinking-label" data-testid="thinking-label"
  ><span class="tl-name">{label}</span><span aria-hidden="true">{shown}<AnimatedDots /></span></span
>

<style>
  .tl-name {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
</style>
